import script from "./ExportOrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportOrderModal.vue?vue&type=script&setup=true&lang=ts"

import "./ExportOrderModal.vue?vue&type=style&index=0&id=22d5d880&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d5d880"]])

export default __exports__